import { ApiError } from '@gorila-shared-ui/components';
import { downloadRequest, getRequest } from './api';
import { publicZoneFencesUrl, zoneFencesUrl } from './urls/zoneFencesUrl';

export const getZoneFencesFileKey = async (zoneType: string): Promise<{ key?: string; error?: ApiError }> => {
  const response = await getRequest(zoneFencesUrl, { queryParams: { zoneType } }, 'text');

  return {
    key: response?.data,
    error: response?.error,
  };
};

export const getZoneFencesFile = async (key: string): Promise<{ file?: Blob; error?: ApiError }> => {
  const response = await downloadRequest(`public/${key}`);

  return {
    file: response?.data?.file,
    error: response?.error,
  };
};

export const getPublicZoneFencesFileKey = async (
  shareLinkId: string,
  zoneType: string,
): Promise<{ url?: string; error?: ApiError }> => {
  const response = await getRequest(publicZoneFencesUrl(shareLinkId), { queryParams: { zoneType } });

  return {
    url: response?.data?.url,
    error: response?.error,
  };
};
